var React = require('react');

function IconCheckboxNormalInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Rectangle_42","data-name":"Rectangle 42","fill":"none","stroke":"#92c8e0","strokeWidth":"1"},[React.createElement("rect",{"width":"20","height":"20","rx":"8","stroke":"none","key":0}),React.createElement("rect",{"x":"0.5","y":"0.5","width":"19","height":"19","rx":"7.5","fill":"none","key":1})]));
}

IconCheckboxNormalInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = IconCheckboxNormalInline;

IconCheckboxNormalInline.default = IconCheckboxNormalInline;
